import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

// parametry requestu
export interface IPostReturnComplaintAttachmentRequest {
  base64: string;
  name: string;
  original_filename: string;
}

// odpowiedź z api
export interface IReturnComplaintAttachment {
  id: number;
  name: string;
  url: string | null;
  original_filename: string;
  extension: string;
}

export const postReturnComplaintAttachment = (
  complaintId: number,
  data: IPostReturnComplaintAttachmentRequest
): Promise<IReturnComplaintAttachment> =>
  axios.post(`/panel/return-complain/requests/${complaintId}/attachments`, data, {
    env: { FormData: { isForm: true } as any }
  });

export const usePostReturnComplaintAttachment = (
  complaintId: number,
  options?: UseMutationOptions<IReturnComplaintAttachment, IError, IPostReturnComplaintAttachmentRequest>
) =>
  useMutation(
    (data: IPostReturnComplaintAttachmentRequest) => postReturnComplaintAttachment(complaintId, data),
    options
  );
